import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
// @ts-ignore
import { GlobalProvider } from 'legacyfrontend/contexts/GlobalContext';
import './fonts/Montserrat-Variable.ttf';
import Map from './legacyfrontend/components/agencies/agencies';
import { withSessionStorageCheck } from './legacyfrontend/helpers/withSessionStorageCheck';
import routes from './legacyfrontend/routes';
import reducers from './legacyfrontend/redux/reducers/index-reduces';
import { useAppName } from './legacyfrontend/hooks/useSafeState';

// Type for the Redux state
type RootState = ReturnType<typeof reducers>;

// Type for route objects
interface RouteType {
  path: string;
  name?: string;
  [key: string]: any;
}

function App() {
  const appName = useAppName();

  return (
    <>
      <Helmet>
        <meta charSet='utf-8' />
        <title>{appName}</title>
      </Helmet>
      <Switch>
        <Route
          path='/agencies-iframe'
          // eslint-disable-next-line react/jsx-no-bind
          render={() => <Map />}
        />
        <GlobalProvider>
          {routes.map((route: RouteType, i: number) => (
            <Route key={`${route.path}${route.name}${i}`} {...route} />
          ))}
        </GlobalProvider>
      </Switch>
    </>
  );
}

export default withSessionStorageCheck(App);
